var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('text-input',_vm._b({attrs:{"data-test":_vm.dataTestAttr,"label":_vm.labelAttr,"prepend-inner-icon":_vm.showIcon ? 'mdi-email' : '',"rules":[_vm.validateEmail],"type":"email"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'text-input',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }